module.exports = __webpack_public_path__ + "meiryo.99590.woff";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/fonts/woff/meiryo.woff
// module id = ./src/_asset/sources/assets/fonts/woff/meiryo.woff
// module chunks = main